import { i18n_t as $t } from '@utils/i18n';

export const getCatalogCategories = () => {
    return {
        ACCOUNTS: $t('common.Accounts'),
        AI_AGENTS: $t('common.AI Agents'),
        FEATURES: $t('common.Features'),
        FEEDBACK: $t('common.Feedback'),
        GENERAL: $t('common.General'),
        GUIDES: $t('common.Guides'),
        LISTEN: $t('common.Listen'),
        MOBILE: $t('common.Mobile'),
        PAGES: $t('common.Pages'),
        REPLAY: $t('common.Replay'),
        REPORTS: $t('common.Reports'),
        SYSTEM: $t('common.System'),
        TRACK_EVENTS: $t('common.Track Events'),
        VISITORS: $t('common.Visitors'),
    };
};
